import { render, staticRenderFns } from "./PlayerUrlCopy.vue?vue&type=template&id=3e1c2fc6&scoped=true"
import script from "./PlayerUrlCopy.vue?vue&type=script&lang=js"
export * from "./PlayerUrlCopy.vue?vue&type=script&lang=js"
import style0 from "./PlayerUrlCopy.vue?vue&type=style&index=0&id=3e1c2fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1c2fc6",
  null
  
)

export default component.exports